package com.macrofocus.eflux.network

import com.macrofocus.eflux.network.logical.LogicalBranchId
import com.macrofocus.eflux.network.logical.logicalBranchIdOf
import com.macrofocus.eflux.ui.svg.dataName
import web.cssom.ClassName
import web.svg.SVGElement
import kotlin.properties.Delegates

class Path(val id: LogicalBranchId, itcmName: String?, element : SVGElement) {
    val fullName = itcmName ?: id.name

    val elements = mutableListOf<SVGElement>(element)
    val logicalBranchIdMap = mutableMapOf<LogicalBranchId,MutableList<SVGElement>>(Pair(logicalBranchIdOf(element.dataName), mutableListOf(element)))

    val logicalBranchId : LogicalBranchId
        get() {return logicalBranchIdMap.toList().first().first}

    fun addElement(element : SVGElement) {
        elements.add(element)
        val id = element.dataName
        logicalBranchIdMap.getOrPut(logicalBranchIdOf(id)) { mutableListOf() }.add(element)
    }

    private val tokens = elements.firstOrNull()?.classList
    var probed: Boolean by TrueBooleanClassname(tokens, ClassName("probed"))::value
    var selected: Boolean by TrueBooleanClassname(tokens, ClassName("selected"))::value
    var valid: Boolean by FalseBooleanClassname(tokens, ClassName("link-invalid"))::value
    var available: Boolean by FalseBooleanClassname(tokens, ClassName("out-of-service"))::value
    // ToDo: not sure, previous was var className: String? by StringClassname(tokens, tokens?.value?.split(" ")?.firstOrNull())::value
    var className: ClassName? by StringClassname(tokens, tokens?.value)::value
    var voltage: ClassName? by VoltageClass(tokens)::value
    var movement: ClassName? by StringClassname(tokens)::value
    var movementReverse: Boolean by FalseBooleanClassname(tokens, ClassName("movement-reverse"))::value
    var thickness: ClassName? by StringClassname(tokens)::value

    var strokeColor: String? by Delegates.observable(null) { _, _, _ ->
        updateStroke()
    }

    var strokeWidth: String? by Delegates.observable(null) { _, _, _ ->
        updateWidth()
    }

    var strokeDasharray: String?  by Delegates.observable(null) { _, _, newValue ->
        elements.forEach {
            if(newValue != null) {
                it.style.setProperty("stroke-dasharray", newValue)
            } else {
                it.style.removeProperty("stroke-dasharray")
            }
        }
    }

    var animationName: String?  by Delegates.observable(null) { _, _, newValue ->
        elements.forEach {
            if(newValue != null) {
                it.style.animationName = newValue
            } else {
                it.style.removeProperty("animation-name")
            }
        }
    }

    var animationDuration: String?  by Delegates.observable(null) { _, _, newValue ->
        elements.forEach {
            if(newValue != null) {
                it.style.animationDuration = newValue
            } else {
                it.style.removeProperty("animation-duration")
            }
        }
    }

    var animationIterationCount: String?  by Delegates.observable(null) { _, _, newValue ->
        elements.forEach {
            if(newValue != null) {
                it.style.animationIterationCount = newValue
            } else {
                it.style.removeProperty("animation-iteration-count")
            }
        }
    }

    var animationTimingFunction: String?  by Delegates.observable(null) { _, _, newValue ->
        elements.forEach {
            if(newValue != null) {
                it.style.animationTimingFunction = newValue
            } else {
                it.style.removeProperty("animation-timing-function")
            }
        }
    }

    var animationDirection: String?  by Delegates.observable(null) { _, _, newValue ->
        elements.forEach {
            if(newValue != null) {
                it.style.animationDirection = newValue
            } else {
                it.style.removeProperty("animation-direction")
            }
        }
    }

    fun updateStroke() {
        val stroke = this.strokeColor
        if (stroke != null) {
            elements.forEach { it.style.setProperty("stroke", stroke) }
        } else {
            elements.forEach { it.style.removeProperty("stroke") }
        }
    }

    fun updateWidth() {
        val stroke = this.strokeWidth
        if(stroke != null) {
            elements.forEach { it.style.setProperty("stroke-width", stroke) }
        } else {
            elements.forEach { it.style.removeProperty("stroke-width") }
        }
    }

}